import { NgModule } from '@angular/core';

import { SearchResultPlaceholderComponent } from './search-result-placeholder.component';

@NgModule({
    declarations: [SearchResultPlaceholderComponent],
    exports: [SearchResultPlaceholderComponent]
})
export class SearchResultPlaceholderModule {}
